<template>
	<div class="admin-sub">
		<!-- Submission title and content -->
		<h2 v-if="!isText">{{ title }}</h2>
		<Submission v-bind="submission" />
		<!-- Break -->
		<hr class="admin-sub__hr" />
		<!-- Submission author and date -->
		<div class="admin-sub__footer">
			<div class="admin-sub__footer__details">
				<p>Submitted by {{ name }} on {{ created }}.</p>
				<table class="admin-sub__footer__details__table">
					<tbody>
						<tr v-if="nickname">
							<th>Nickname</th>
							<td>{{ nickname }}</td>
						</tr>
						<tr v-if="email">
							<th>Email</th>
							<td>
								<a :href="mailto">{{ email }}</a>
							</td>
						</tr>
						<tr v-if="studentNumber">
							<th>Student ID</th>
							<td>{{ studentNumber }}</td>
						</tr>
						<tr>
							<th>IP address</th>
							<td>{{ ip || 'N/A' }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="admin-sub__footer__actions">
				<Action
					v-if="canApprove"
					:disabled="updating"
					class="approve"
					title="Approve"
					@click="approve"
				>
					<IconApprove />
				</Action>
				<Action
					v-if="canDecline"
					:disabled="updating"
					class="decline"
					title="Decline"
					@click="decline"
				>
					<IconDecline />
				</Action>
			</div>
		</div>
	</div>
</template>

<script>
import IconApprove from 'mdi-vue/Check'
import IconDecline from 'mdi-vue/Close'
import Submission from '@/components/shared/Submission'
import Action from '@/components/shared/Action'

import { enums } from 'protoswipe-shared'
const { CampaignType, SubmissionStatus } = enums

export default {
	name: 'AdminSubmission',
	props: {
		id: Number,
		title: String,
		image: Object,
		drawing: String,
		status: String,
		name: String,
		nickname: String,
		email: String,
		studentNumber: String,
		campaign: Object,
		ip: String,
		created_at: String,
		updating: Boolean,
		isShortlist: Boolean
	},
	computed: {
		moreInfo() {
			return [this.studentNumber, this.email].filter(Boolean).join(', ')
		},
		mailto() {
			return `mailto:${this.email}`
		},
		isInCurrentRound() {
			return this.round >= this.campaign.round
		},
		canApprove() {
			return (
				!this.isShortlist &&
				this.isInCurrentRound &&
				this.status !== SubmissionStatus.approved
			)
		},
		canDecline() {
			return (
				!this.isShortlist &&
				this.isInCurrentRound &&
				this.status !== SubmissionStatus.declined
			)
		},
		created() {
			return new Date(this.created_at).toLocaleDateString('en-AU', {
				year: 'numeric',
				month: 'long',
				day: 'numeric'
			})
		},
		isText() {
			return this.campaign.type === CampaignType.text
		},
		submission() {
			return {
				campaign: this.campaign,
				title: this.title,
				image: this.image,
				drawing: this.drawing
			}
		}
	},
	methods: {
		update(status) {
			this.$emit('update', { id: this.id, status })
		},
		approve() {
			this.update('approved')
		},
		decline() {
			this.update('declined')
		}
	},
	components: {
		Action,
		IconApprove,
		IconDecline,
		Submission
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

.admin-sub {
	@include truncate-margin;

	&__hr {
		border: none;
		border-bottom: 1px solid $black;
		margin: 1rem 0;
	}

	&__footer {
		@extend %flex-row;

		&__details {
			color: $black;
			font-size: 0.85rem;
			flex-grow: 1;
			margin-right: 1rem;
			text-align: left;

			> :not(:last-child) {
				margin-bottom: 1em;
			}

			&__table {
				border-collapse: collapse;
				color: $grey-48;
				font-family: monospace;

				th {
					padding-right: 1.5em;
				}
			}

			p {
				margin: 0;
			}
		}

		&__actions {
			flex-shrink: 0;

			.approve {
				color: $green-50;
			}
			.decline {
				color: $red-85;
			}
		}
	}

	@include mq(md) {
		&__hr {
			margin: 2rem 0;
		}

		&__footer__details {
			font-size: 1rem;
		}
	}
}
</style>
